
import { Component, Vue } from "vue-property-decorator";

import NoticeListItem from '@/components/Notices/NoticeListItem.vue';
import { INotice, INoticeUserState, NoticePriority } from '@/store/notice-store';
import { RawLocation } from 'vue-router';


@Component({
  components: { 
    NoticeListItem,
  },
})
export default class Notices extends Vue {
  
  get passengerId(): number | null {
    const rawPassengerId = this.$route.query.passengerId;

    if (!rawPassengerId) {
      return null;
    }

    const parsedPassengerId = Number.parseInt(String(rawPassengerId), 10);
    if (Number.isNaN(parsedPassengerId)) {
      return null;
    }

    return parsedPassengerId;
  }

  get notices() {
    const notices = this.$store.state.notice.notices as INotice[];

    if (this.passengerId !== null) {
      return notices.filter(n => n.passengers.includes(this.passengerId as number));
    }

    return notices;
  }

  get noticeStates() {
    return this.$store.state.notice.userStates as INoticeUserState[];
  }

  get activeNotices() {
    return this.notices.filter(n => {
      if (n.priority === NoticePriority.Sticky) {
        return true;
      }
      return !this.noticeStates.some(ns => ns.noticeId === n.id && ns.readAt);
    });
  }

  get readNotices() {
    return this.notices.filter(n => {
      if (n.priority === NoticePriority.Sticky) {
        return false;
      }
      return this.noticeStates.some(ns => ns.noticeId === n.id && ns.readAt);
    });
  }

  get backButtonAriaLabel() {
    return `${this.$t('general.button.back')}: ${this.$t('menu.passengers')}`;
  }

  get backLocation() {
    return { name: 'passengers' } as RawLocation;
  }


  async mounted() {
    await this.$store.dispatch('notice/getNotices');
    await this.$store.dispatch('notice/getNoticeUserStates');
  }


}
